export default (options) => {
  return {
    applyHtmlTags: ['bold'].map(tag => tag.toLowerCase())
  }
}
